import OFiltersPanel from './o-filters-panel';

export default OFiltersPanel;